import * as React from "react"

const MOBILE_BREAKPOINT = 768

/**
 * Subscribes to a media query. Returns false during the first render (before
 * the effect runs), so callers that branch on layout should tolerate a
 * desktop-first initial paint.
 */
export function useMediaQuery(query: string) {
  const [matches, setMatches] = React.useState(false)

  React.useEffect(() => {
    const mql = window.matchMedia(query)
    const onChange = () => setMatches(mql.matches)
    mql.addEventListener("change", onChange)
    setMatches(mql.matches)
    return () => mql.removeEventListener("change", onChange)
  }, [query])

  return matches
}

export function useIsMobile() {
  return useMediaQuery(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`)
}
